import { createFileRoute } from '@tanstack/react-router'
import { ChecksList } from '@thom/folio-ui/pages/checks'

export const Route = createFileRoute('/_authenticated/checks/')({
	component: () => (
		<div className='mx-auto w-full max-w-5xl'>
			<ChecksList />
		</div>
	),
})
